import { render, staticRenderFns } from "./NewRegisterMessageSms.vue?vue&type=template&id=2eaacbd6&"
import script from "./NewRegisterMessageSms.js?vue&type=script&lang=js&"
export * from "./NewRegisterMessageSms.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports